module.exports = __webpack_public_path__ + "static/media/team21.6bd1c3ed.png";